<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ehCMCX/tc-custom/9780830843787.jpg?1696024724363" alt="This image is the cover for the book The Holy Spirit in the New Testament"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Holy Spirit in the New Testament
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>In the early church, miraculous workings of the Holy Spirit were normal and normative.</strong> Today an ever-increasing number of Christians worldwide self-identify as Pentecostal or charismatic. William A. Simmons argues that this means the church needs a Spirit-centered interpretation of Scripture informed by a Pentecostal lens.</p> <p>In <em>The Holy Spirit in the New Testament</em>, Simmons provides an accessible New Testament introduction that discusses themes and passages of particular interest to Pentecostal readers. Each chapter explores the presence of the Spirit in a biblical book, then offers devotional applications to help readers respond to the text. In Matthew, for example, we discover that there is no Messianic era apart from the Spirit. For Paul in Romans, the Holy Spirit is the authenticating power and emotive heart of God. And Revelation is permeated with the illuminating voice of the Spirit from beginning to end.</p> <p>A Spirit-centered reading breaks down divisions between reason and spirit, mind and emotion. This book opens a dialogue between the academy and the church, demonstrating how sound exegesis speaks to Spirit-filled Christians. In the world and writings of the New Testament authors, we continue to encounter the revelatory presence of God.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William A. Simmons
      </h2>
      
      <p class="authorDescription body article"><p>William A. Simmons (PhD, University of St. Andrews) is a professor of New Testament and Greek at Lee University, where he teaches graduate and undergraduate classes in the areas of Pauline studies and Koine Greek. He is the author of several books including <em>Peoples of the New Testament World</em>, <em>A Pentecostal Approach to Bible Study: Leader's Guide</em>, and Bible studies on James, Ephesians, and Philippians.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0bc90ca1